import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/activate-bundle',
    name: 'ActivateBundle',
    component: () => import(/* webpackChunkName: "about" */ '@/overlays/ActivateBundle.vue')
  },
  {
    path: '/bundle-activated-successfully',
    name: 'SuccessfulActivation',
    component: () => import(/* webpackChunkName: "about" */ '@/overlays/SuccessfulActivation.vue')
  },
  {
    path: '/bundle-activation-failed',
    name: 'FailedActivation',
    component: () => import(/* webpackChunkName: "about" */ '@/overlays/FailedActivation.vue')
  }
]



const router = new VueRouter({
  routes
})


export default router